import { STATUS_EFFECTS } from '../../utils/game/cardMesh';
import { t } from '../../localization/t';

const STATUS_BY_KEY = new Map(STATUS_EFFECTS.map((e) => [e.key, e]));

// 30/16 cqw = 30px at scale 1.0; scales with canvas like everything else.
const BADGE_SIZE = '1.875cqw';
const STATUS_GRID_GAP = '0.625cqw';

function statusBadgeStyle(color) {
  return {
    width: BADGE_SIZE,
    height: BADGE_SIZE,
    borderRadius: '50%',
    border: '2px solid rgba(220,180,80,0.85)',
    background: `radial-gradient(circle at 40% 35%, ${color}ee, ${color}bb 55%, ${color}88 100%)`,
    color: '#fff',
    boxShadow: `0 0 14px ${color}55, inset 0 1px 0 rgba(255,255,255,0.25), inset 0 -2px 4px rgba(0,0,0,0.3), 0 4px 10px rgba(0,0,0,0.6)`,
    fontSize: '0.5625cqw',
    fontWeight: 700,
    letterSpacing: '0.03em',
    textShadow: '0 1px 3px rgba(0,0,0,0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 auto',
  };
}

/**
 * Right-side stack of circular badges for the hovered card's active
 * status effects. Position is mutated each frame by
 * updateHoverStatusOverlayPosition() in GameBoard so the column
 * tracks the card's top-right corner as the camera pans. Hidden when
 * the card has no statuses.
 */
export default function HoverStatusBadges({ hoverRef, statuses }) {
  const list = statuses || [];
  return (
    <div
      ref={hoverRef}
      aria-hidden="true"
      style={{
        position: 'fixed',
        display: list.length > 0 ? 'grid' : 'none',
        gridAutoFlow: 'column',
        gridTemplateRows: `repeat(3, ${BADGE_SIZE})`,
        gap: STATUS_GRID_GAP,
        pointerEvents: 'none',
        zIndex: 49,
        left: 0,
        top: 0,
        willChange: 'transform',
      }}
    >
      {list.map((key) => {
        const effect = STATUS_BY_KEY.get(key);
        if (!effect) return null;
        return (
          <div key={key} style={statusBadgeStyle(effect.color)} title={t(effect.label)}>
            {effect.abbr}
          </div>
        );
      })}
    </div>
  );
}
